export const notificationGroups = {
  name: 'Notification Group |||| Notification Groups',
  list: {
    title: 'Notification Groups',
    subtitle: 'Manage notification groups and their members',
    members: 'members',
    filters: {
      search: 'Search by name or description',
      type: 'Type',
      active: 'Status',
    },
  },
  create: {
    title: 'Create Notification Group',
    subtitle: 'Set up a new group for receiving notifications',
    backToList: 'Back to notification groups',
  },
  edit: {
    title: 'Edit Notification Group',
    subtitle: 'Manage group settings and members',
    backToList: 'Back to notification groups',
  },
  delete: {
    confirmTitle: 'Delete Notification Group',
    confirmContent: 'Are you sure you want to delete this notification group? This action cannot be undone.',
  },
  fields: {
    name: 'Group Name',
    description: 'Description',
    type: 'Type',
    channels: 'Notification Channels',
    memberCount: 'Members',
    active: 'Active',
    createdAt: 'Created At',
    updatedAt: 'Updated At',
    createdBy: 'Created By',
    updatedBy: 'Updated By',
    metadata: 'Metadata',
  },
  types: {
    site: 'Site',
    charger: 'Charger',
    payment: 'Payment',
    system: 'System',
    custom: 'Custom',
  },
  channels: {
    email: 'Email',
    sms: 'SMS',
    whatsapp: 'WhatsApp',
    push: 'Push',
    slack: 'Slack',
  },
  help: {
    name: 'A unique name for this notification group',
    description: 'Optional description of the group\'s purpose',
    type: 'The type of notifications this group handles',
    channels: 'Default notification channels for this group',
    active: 'Inactive groups will not receive notifications',
  },
  sections: {
    basicInfo: 'Basic Information',
    channelsConfig: 'Channels Configuration',
    metadata: 'Metadata',
  },
  tabs: {
    general: 'General',
    members: 'Members',
    assignments: 'Assignments',
  },
  assignments: {
    title: 'Resource Assignments',
    addButton: 'Add Assignment',
    loading: 'Loading assignments...',
    noAssignments: 'No resource assignments yet',
    noAssignmentsHelp: 'Assign this group to sites, chargers, or other resources to receive notifications',
    info: 'This group is assigned to the following resources. To manage assignments, go to Notification Assignments.',
  },
  members: {
    title: 'Group Members',
    empty: 'No members in this group yet',
    add: 'Add Members',
    remove: 'Remove',
    editChannels: 'Edit Channels',
    overridden: 'Overridden',
    loadError: 'Failed to load members',
    addSuccess: 'Members added successfully',
    addError: 'Failed to add members',
    updateSuccess: 'Member updated successfully',
    updateError: 'Failed to update member',
    removeSuccess: 'Member removed successfully',
    removeError: 'Failed to remove member',
    selectAtLeastOne: 'Please select at least one user',
    loadUsersError: 'Failed to load users',
    fields: {
      name: 'Name',
      email: 'Email',
      role: 'Role',
      channels: 'Channels',
      active: 'Active',
      addedAt: 'Added At',
      actions: 'Actions',
    },
    removeConfirm: {
      title: 'Remove Member',
      content: 'Are you sure you want to remove %{name} from this group?',
    },
    addDialog: {
      title: 'Add Members to Group',
      search: 'Search users by name or email',
      noUsers: 'No available users to add',
      selectUsers: 'Selected %{count} users',
      overrideChannels: 'Override default channels',
      selectChannels: 'Select notification channels',
      add: 'Add %{count} Members',
    },
    editDialog: {
      title: 'Edit Member Settings',
      active: 'Active Member',
      activeHelp: 'Inactive members will not receive notifications',
      overrideChannels: 'Override group channels',
      usingGroupChannels: 'This member uses the group\'s default channels',
      selectChannels: 'Select notification channels for this member',
      groupChannels: 'Group default channels',
      resetToGroup: 'Reset to Group Defaults',
    },
  },
  notifications: {
    createSuccess: 'Notification group created successfully',
    updateSuccess: 'Notification group updated successfully',
    deleteSuccess: 'Notification group deleted successfully',
  },
};